export default "__VITE_ASSET__B47CYQFX__"